import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import t from '@instructure/quiz-i18n/format-message';
import { View } from '@instructure/ui-view';
import { Text } from '@instructure/ui-text';
import { Heading } from '@instructure/ui-heading';
import { Tooltip } from '@instructure/ui-tooltip';
import { Tray } from '@instructure/ui-tray';
import { Button, CloseButton } from '@instructure/ui-buttons';
import { TruncateText } from '@instructure/ui-truncate-text';
import { Modal } from '@instructure/ui-modal';
import { Flex, liveRegion } from '@instructure/quiz-common';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
export var ModerateTray = /*#__PURE__*/function (_Component) {
  function ModerateTray() {
    var _this2;
    _classCallCheck(this, ModerateTray);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, ModerateTray, [].concat(args));
    _defineProperty(_this2, "state", {
      titleIsTruncated: false,
      participantNameIsTruncated: false
    });
    _defineProperty(_this2, "handleTitleUpdate", function (titleIsTruncated) {
      if (_this2.state.titleIsTruncated !== titleIsTruncated) {
        _this2.setState({
          titleIsTruncated: titleIsTruncated
        });
      }
    });
    _defineProperty(_this2, "handleParticipantNameUpdate", function (participantNameIsTruncated) {
      if (_this2.state.participantNameIsTruncated !== participantNameIsTruncated) {
        _this2.setState({
          participantNameIsTruncated: participantNameIsTruncated
        });
      }
    });
    _defineProperty(_this2, "onClose", function () {
      _this2.props.onClose();
    });
    _defineProperty(_this2, "handleTrayExited", function () {
      _this2.setState({
        titleIsTruncated: false,
        participantNameIsTruncated: false
      });
    });
    _defineProperty(_this2, "setCloseRef", function (el) {
      return _this2.closeRef = el;
    });
    _defineProperty(_this2, "setTrayRef", function (el) {
      return _this2.trayRef = el;
    });
    _defineProperty(_this2, "getTrayRef", function () {
      return _this2.trayRef;
    });
    _defineProperty(_this2, "handleSave", function () {
      _this2.props.onSave();
      _this2.props.closeTray();
    });
    _defineProperty(_this2, "renderTitleAndCloseButton", function () {
      return /*#__PURE__*/React.createElement(Modal.Header, {
        "data-automation": "moderate-tray-header"
      }, /*#__PURE__*/React.createElement(CloseButton, {
        onClick: _this2.props.closeTray,
        elementRef: _this2.setCloseRef,
        placement: "end",
        offset: "medium",
        screenReaderLabel: t('Close')
      }), _this2.props.atteqApplyChangesToCurrentQuizAttemptsEnabled ? /*#__PURE__*/React.createElement(Heading, {
        level: "h3"
      }, /*#__PURE__*/React.createElement(ScreenReaderContent, null, t('Current Quiz Accommodation')), t('Current Quiz Accommodation')) : _this2.renderHeading());
    });
    _defineProperty(_this2, "renderChildren", function () {
      return React.Children.map(_this2.props.children, function (child) {
        if (!child) return null;
        return React.cloneElement(child, {
          trayResetFocus: function trayResetFocus() {
            return _this2.closeRef.focus();
          }
        });
      });
    });
    _defineProperty(_this2, "renderFooter", function () {
      return /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
        onClick: _this2.props.closeTray,
        margin: "0 x-small 0 0"
      }, t('Cancel')), /*#__PURE__*/React.createElement(Button, {
        color: "primary",
        type: "submit",
        onClick: _this2.handleSave
      }, t('Apply')));
    });
    return _this2;
  }
  _inherits(ModerateTray, _Component);
  return _createClass(ModerateTray, [{
    key: "renderHeading",
    value: function renderHeading() {
      var _this3 = this;
      return this.state.titleIsTruncated ? /*#__PURE__*/React.createElement(Tooltip, {
        placement: "start",
        renderTip: this.labelText(),
        mountNode: this.getTrayRef || null
      }, function (_ref) {
        var focused = _ref.focused;
        return _this3.renderHeadingName({
          focused: focused
        });
      }) : this.renderHeadingName();
    }
  }, {
    key: "renderHeadingName",
    value: function renderHeadingName() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        focused = _ref2.focused;
      return (
        /*#__PURE__*/
        // When using TruncateText inside a Tooltip, a focusable wrapper element is required
        // tabIndex={0} makes the div focusable and allows KO users to access the tooltip
        React.createElement(Heading, {
          display: "block",
          borderRadius: "small",
          position: "relative",
          withFocusOutline: this.state.titleIsTruncated && focused,
          level: "h3",
          tabIndex: this.state.isTruncated ? 0 : null
        }, /*#__PURE__*/React.createElement(ScreenReaderContent, null, this.labelText()), /*#__PURE__*/React.createElement(TruncateText, {
          "aria-hidden": "true",
          maxLines: 2,
          truncate: "character",
          onUpdate: this.handleTitleUpdate
        }, this.labelText()))
      );
    }
  }, {
    key: "renderName",
    value: function renderName(renderProps) {
      var focused = renderProps && renderProps.focused;
      return (
        /*#__PURE__*/
        // When using TruncateText inside a Tooltip, a focusable wrapper element is required
        // tabIndex={0} makes the div focusable and allows KO users to access the tooltip
        React.createElement(View, {
          display: "block",
          borderRadius: "small",
          position: "relative",
          withFocusOutline: this.state.participantNameIsTruncated && focused,
          tabIndex: this.state.participantNameIsTruncated ? 0 : null
        }, /*#__PURE__*/React.createElement(ScreenReaderContent, null, this.props.participantName), /*#__PURE__*/React.createElement(TruncateText, {
          "aria-hidden": "true",
          maxLines: 2,
          truncate: "character",
          onUpdate: this.handleParticipantNameUpdate
        }, /*#__PURE__*/React.createElement(Text, {
          weight: "bold"
        }, this.props.participantName)))
      );
    }
  }, {
    key: "renderNameWithTooltip",
    value: function renderNameWithTooltip() {
      var _this4 = this;
      return this.state.titleIsTruncated ? /*#__PURE__*/React.createElement(Tooltip, {
        placement: "start",
        renderTip: this.props.participantName,
        mountNode: this.getTrayRef || null
      }, function (_ref3) {
        var focused = _ref3.focused;
        return _this4.renderName({
          focused: focused
        });
      }) : this.renderName();
    }
  }, {
    key: "labelText",
    value: function labelText() {
      if (this.props.atteqApplyChangesToCurrentQuizAttemptsEnabled) {
        return t('Current Quiz Accommodation');
      }
      if (this.props.participantName) {
        return this.props.participantName;
      }
      return t('Moderate');
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Tray, {
        label: this.labelText(),
        liveRegion: liveRegion,
        onClose: this.onClose,
        onDismiss: this.props.closeTray,
        onExited: this.handleTrayExited,
        open: this.props.isOpen,
        placement: "end",
        size: this.props.atteqApplyChangesToCurrentQuizAttemptsEnabled ? 'regular' : undefined,
        shouldCloseOnDocumentClick: true,
        ref: this.setTrayRef
      }, /*#__PURE__*/React.createElement(Flex, {
        as: "div",
        direction: "column",
        height: "100vh"
      }, this.renderTitleAndCloseButton(), this.props.atteqApplyChangesToCurrentQuizAttemptsEnabled && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Flex.Item, {
        padding: "medium medium 0 medium"
      }, this.renderNameWithTooltip()), /*#__PURE__*/React.createElement(Flex.Item, {
        padding: "medium medium 0"
      }, t.rich('These settings apply to the <0>current quiz only, including the in-progress attempts.</0>', [function (_ref4) {
        var children = _ref4.children;
        return /*#__PURE__*/React.createElement(Text, {
          weight: "bold",
          key: "0"
        }, children);
      }]))), /*#__PURE__*/React.createElement(Flex.Item, {
        shouldGrow: true,
        padding: "medium medium 0"
      }, this.renderChildren()), /*#__PURE__*/React.createElement(Flex.Item, null, this.renderFooter())));
    }
  }]);
}(Component);
_defineProperty(ModerateTray, "propTypes", {
  children: PropTypes.node.isRequired,
  closeTray: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onSave: PropTypes.func.isRequired,
  participantName: PropTypes.string,
  atteqApplyChangesToCurrentQuizAttemptsEnabled: PropTypes.bool.isRequired
});
_defineProperty(ModerateTray, "defaultProps", {
  onClose: void 0,
  participantName: null
});
export default ModerateTray;